import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link, Redirect, withRouter} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import YCComponent from "./yc-component";
import assets from '../assets';
import {Button, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";

class GameIntro extends YCComponent {

    componentDidMount() {
        this.setTitle('Soutěž');
    }

    componentWillUnmount() {
        this.setTitle();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { hash } = nextProps.location;

        switch (hash) {
            case "#1":
                this.setState({ activeTab: '1' });
                break;

            case "#2":
                this.setState({ activeTab: '2' });
                break;

            default:
                this.setState({ activeTab: '1' });
        }
        if (hash && hash.startsWith('#')) {

        } else {

        }
    }

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    };

    tabClassNames(object = {}) {
        let classNames = {};
        Object.assign(classNames, object);
        return Object.keys(classNames).filter((className) => classNames[className]).join(' ');
    }

    render() {
        let { from } = this.props.location.state || { from: { pathname: '/dashboard' } };

        if (this.props.auth.authenticating) {
            return (
                <div>
                    <div className='text-center'>
                        <p>Loading</p>
                        <p><FontAwesomeIcon icon={['far', 'spinner']} spin/></p>
                    </div>
                </div>
            );
        }

        if (this.props.auth.isAuthenticated) {
            return (
                <Redirect to={from}/>
            );
        }

        return (
            <div id='game-intro' className='container'>
                <div className='text-center'>
                    <h1 className='page-title'>Zapoj se</h1>
                    <div className='separate'>
                        <p>Největší česká soutěž na finanční gramotnost<br/>Soutěž běží od podzimu do jara.</p>
                    </div>
                </div>

                <div className='game-auth row'>
                    <div className='col-lg-4'>
                        <div className='purple-card text-center'>
                            <p>Učitel po přihlášení uvidí všechny své týmy</p>
                            <Link to='/lecturers/sign-in' className='btn btn-white btn-block'>Přihlášení pro učitele</Link>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='purple-card text-center'>
                            <p>Přihlašte se a začněte plnit úkoly, nebo se podívejte, jak si vedete</p>
                            <Link to='/students/sign-in' className='btn btn-white btn-block'>Přihlášení pro týmy</Link>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='white-card text-center'>
                            <p>Ještě nesoutěžíte? Nevadí. Pojďte se zaregistrovat.</p>
                            <Link to='/lecturers/registration' className='btn btn-white-secondary btn-block'>Registrujte se</Link>
                        </div>
                    </div>
                </div>

                <p>
                    <Link to='#1' className={'btn btn-primary ' + this.tabClassNames({ active: this.state.activeTab === '1' })} onClick={() => this.toggle('1')}>Představení soutěže pro 2. stupeň</Link>{' '}
                    <Link to='#2' className={'btn btn-primary ' + this.tabClassNames({ active: this.state.activeTab === '2' })} onClick={() => this.toggle('2')}>Představení soutěže pro 1. stupeň</Link>{' '}
                </p>

                <div>
                    <div className={'info-content' + this.tabClassNames({ active: this.state.activeTab === '1' })}>
                        <div className='card text-center'>
                            <div className='card-body'>
                                <h1>Jak soutěž funguje?</h1>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <img src={assets.how_it_works.vytvorit_tim} className='img-fluid'/>
                                        <h2>Vytvoř tým</h2>
                                        <p>Jedná se o týmovou soutěž pro 3 až 4členné týmy dětí + 1 učitele či lektora a pro rodinné týmy. Můžeš se dát dohromady se spolužáky, kamarády, nebo třeba s ostatními z vaší rodiny.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.how_it_works.rozpocet} className='img-fluid'/>
                                        <h2>Spravuj rozpočet</h2>
                                        <p>Naplánujte si rozpočet a jeho položky. Když bude dobrý, budete připraveni i na neplánované životní situace.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.how_it_works.ulohy} className='img-fluid'/>
                                        <h2>Splň úkoly a vyhraj ceny</h2>
                                        <p>Pokud chcete v soutěži uspět, je potřeba splnit kromě základních úloh alespoň některé dobrovolné kreativní a bonusové úkoly. Jen tak můžete dosáhnout na některou z cen.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='card text-center'>
                            <div className='card-body'>
                                <h1>Kdo se může zapojit a jak se hraje</h1>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <img src={assets.who_can_join.who} className='img-fluid'/>
                                        <h2>Týmová práce</h2>
                                        <p>V životě budete možná na plánování rodinných financí sami. U nás ne. Hra je vytvořena pro týmy složené z 3 - 5 hráčů.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.who_can_join.task_kinds} className='img-fluid'/>
                                        <h2>3 typy úkolů</h2>
                                        <p>V průběhu hry se setkáte s třemi typy úkolů - základními, kreativními a bonusovými. Pokud chcete uspět, musíte se věnovat všem.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.who_can_join.best_team} className='img-fluid'/>
                                        <h2>Cíl hry</h2>
                                        <p>Smyslem hry je vyzkoušet si vedení financí jedné domácnosti. Pro ty, kterým se bude dařit nejlíp, máme přichystanou odměnu.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='card text-center'>
                            <div className='card-body'>
                                <h1>Proč se zapojit?</h1>
                            </div>
                            <div className='reasons'>
                                <div>Rozpočti si to! je největší soutěž zaměřená na finanční gramotnost v České republice.</div>
                                <div>Hráči si osvojí základní principy správného domácího hospodaření, které jsou důležité pro spokojený život.</div>
                                <div>Díky týmové spolupráci si hráči rozvíjí další kompetence a mají možnost svá rozhodnutí sdílet a diskutovat.</div>
                                <div>Soutěž je zajímavým výukovým nástrojem, který je v souladu s požadavky Rámcových vzdělávacích programů.</div>
                            </div>
                        </div>
                    </div>

                    <div className={'info-content' + this.tabClassNames({ active: this.state.activeTab === '2' })}>
                        <div className='card text-center'>
                            <div className='card-body'>
                                <h1>Jak soutěž funguje?</h1>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <img src={assets.how_it_works.vytvorit_tim} className='img-fluid'/>
                                        <h2>Vytvoř tým</h2>
                                        <p>Jedná se o týmovou soutěž pro 3-4členné týmy dětí + 1 učitele či lektora a pro rodinné týmy. Můžeš se dát dohromady se spolužáky, kamarády, nebo třeba s ostatními z vaší rodiny.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.how_it_works.rozpocet} className='img-fluid'/>
                                        <h2>Zamysli se nad finanční gramotností</h2>
                                        <p>Jak se chová finančně gramotný člověk? Během úkolů budete pronikat do tajů finanční gramotnosti. Cestu si můžete zvolit do jisté míry sami. Buďte kreativní!</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.how_it_works.ulohy} className='img-fluid'/>
                                        <h2>Splň úkoly a vyhraj ceny</h2>
                                        <p>Čím více úkolů splníte, tím více získáte chechtáků. Úkoly jsou rozděleny do jednotlivých kategorií podle jejich zaměření a na své si tu přijde snad každý...</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='card text-center'>
                            <div className='card-body'>
                                <h1>Kdo se může zapojit a jak se hraje</h1>
                                <div className='row'>
                                    <div className='col-lg-4'>
                                        <img src={assets.who_can_join.who} className='img-fluid'/>
                                        <h2>Školní a rodinné týmy</h2>
                                        <p>V životě budete možná na plánování domácích financí sami. U nás ne. Hra je vytvořena pro týmy žáků 1. stupně ZŠ a jejich učitele, lektory nebo rodiče.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.who_can_join.task_kinds} className='img-fluid'/>
                                        <h2>6 kategorií úkolů</h2>
                                        <p>Čekají vás úkoly s finanční tématikou, kde můžete projevit svůj rozum i cit a tvořivost. Můžete se zaměřit jen na ty kategorie, které jsou vám blízké, ovšem více splněných úkolů = více chechtáků a větší šance na postup do finále.</p>
                                    </div>
                                    <div className='col-lg-4'>
                                        <img src={assets.who_can_join.best_team} className='img-fluid'/>
                                        <h2>Cíl hry</h2>
                                        <p>Smyslem hry je proniknout do tajů finanční gramotnosti prostřednictvím zábavných a kreativních aktivit. Hloubku si každý tým určuje sám.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='card text-center'>
                            <div className='card-body'>
                                <h1>Proč se zapojit?</h1>
                            </div>
                            <div className='reasons'>
                                <div>Rozpočti si to! je největší soutěž zaměřená na finanční gramotnost v České republice.</div>
                                <div>Hráči si osvojí základní principy správného domácího hospodaření, které jsou důležité pro spokojený život.</div>
                                <div>Díky týmové spolupráci si hráči rozvíjí další kompetence a mají možnost svá rozhodnutí sdílet a diskutovat.</div>
                                <div>Soutěž je zajímavým výukovým nástrojem, který je v souladu s požadavky Rámcových vzdělávacích programů.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}


function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({}, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(GameIntro));
